export class SummaryItem {
  key: string;
  label: string;
  currentValue: string;
  defaultValue: string;
  category: string;
  uniqueLabel: string | undefined; // Unique label for display purposes
  changed: boolean;

  constructor(
    key: string,
    label: string,
    currentValue: string | undefined,
    defaultValue: string,
    category: string,
    uniqueLabel: string | undefined
  ) {
    this.key = key;
    this.label = label;
    this.currentValue = currentValue || "";
    this.defaultValue = defaultValue;
    this.category = category;
    this.uniqueLabel = uniqueLabel;
    // the summary item is marked as changed by default if the current value
    // differs from the default value
    this.changed = this.currentValue !== this.defaultValue;
  }
}
